import { inject, Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { AddParamsService, Params } from '../utilis/add-params-service';
import { Customer } from '../../models/customer';
import { Observable } from 'rxjs';
import { Generic } from '../../models/generic';
import { GenericPaginated } from '../../models/generic-paginated';
import { WalletTransaction } from '../../models/wallet-transaction';
import { PaymentTransaction } from '../../models/payment-transaction';
import { PointTransaction } from '../../models/point-transaction';
import { CustomerActivity } from '../../models/customer-activity';

@Injectable({
  providedIn: 'root'
})
export class CustomerService {
  private baseUrl = environment.url;

  private http = inject(HttpClient)
  private addParamsService = inject(AddParamsService)

  getCustomersList = (params?: Params): Observable<GenericPaginated<Customer>> => {
    return this.http.get<GenericPaginated<Customer>>(`${this.baseUrl}/customers`, {
      params: this.addParamsService.addParams(params)
    });
  }

  getCustomerById = (customerId: string): Observable<Generic<Customer>> => {
    return this.http.get<Generic<Customer>>(`${this.baseUrl}/customers/${customerId}`);
  }

  updateCustomer = (customerID: number, payload: object): Observable<Customer> => {
    return this.http.patch<Customer>(`${this.baseUrl}/customers/${customerID}`, payload)
  }

  deleteCustomer = (customerID: number): Observable<Customer> => {
    return this.http.delete<Customer>(`${this.baseUrl}/customers/${customerID}`)
  }

  getCustomerWalletTransactionHistory = (customerID: string, params?: Params): Observable<GenericPaginated<WalletTransaction>> => {
    return this.http.get<GenericPaginated<WalletTransaction>>(`${this.baseUrl}/customers/${customerID}/wallet/transactions`, {
      params: this.addParamsService.addParams(params)
    })
  }

  getCustomerPaymentTransactionHistory = (customerID: string, params?: Params): Observable<GenericPaginated<PaymentTransaction>> => {
    return this.http.get<GenericPaginated<PaymentTransaction>>(`${this.baseUrl}/customers/${customerID}/payments/transactions`, {
      params: this.addParamsService.addParams(params)
    })
  }

  getCustomerPointTransactionHistory = (customerID: string, params?: Params): Observable<GenericPaginated<PointTransaction>> => {
    return this.http.get<GenericPaginated<PointTransaction>>(`${this.baseUrl}/customers/${customerID}/points/transactions`, {
      params: this.addParamsService.addParams(params)
    })
  }

  getCustomersActivityList = (customerID: string, params?: Params): Observable<GenericPaginated<CustomerActivity>> => {
    return this.http.get<GenericPaginated<CustomerActivity>>(`${this.baseUrl}/customers/${customerID}/activities`, {
      params: this.addParamsService.addParams(params)
    })
  }

  chargeCustomerCard = (customerId: number, payload: object): Observable<PaymentTransaction> => {
    return this.http.post<PaymentTransaction>(`${this.baseUrl}/customers/${customerId}/payments/charge-card`, payload);
  }
}